/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DeleteDepartmentCategoryRequestBody = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
    },
};